import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, cn, Typography } from '@pw-tech/omni-ui'
import useGetAvgCommissions from '@api/hooks/ambassdor/useGetAvgCommissions'
import { useAmbassadorContext } from '@context/context'
import { EarnTypesDetails, EarnTypesDetailsCSC } from '@utils/StaticDataSet'
import { AMBASSADOR_SALE_TYPE, PROGRAM_TYPE } from '@utils/enum'
import CustomStepper from '@components/Common/CustomStepper/CustomStepper'
import questionMarkCircle from '@assets/images/sales/question-mark-circle.svg'
import styles from './AssistedEarnCard.module.css'
import { Cross } from '@corecomponents/icons'

const AssistEarnCard = ({
  isOpenPopupCard,
  onClose,
  isActive,
  setIsOpenAssistedVideoModal,
  isFirstTime,
  cameFrom,
}: any) => {
  const navigate = useNavigate()
  const { myProfileValue } = useAmbassadorContext()
  const { data: avgCommission } = useGetAvgCommissions({
    programType: myProfileValue?.programType,
    orgFeatType: AMBASSADOR_SALE_TYPE.ASSISTED,
  })

  const handleActiveHeader = (item: any) => {
    return (
      <div className={styles.cardHeader}>
        <div className={styles.titleWrapper}>
          <Typography variant="heading4" weight="semi-bold" color="#1B2124">
            {item.title}
          </Typography>

          {item.tag && (
            <Typography
              variant="small"
              color="#1B2124"
              weight="semi-bold"
              className={`${styles.shimmer} ${styles.newTag}`}
            >
              New
            </Typography>
          )}
        </div>

        {item.infoIcon && (
          <img
            className={styles.infoIcon}
            src={questionMarkCircle}
            alt="Question"
            onClick={() => {
              onClose()
              isFirstTime && setIsOpenAssistedVideoModal(true)
            }}
          />
        )}
      </div>
    )
  }

  const gridClass = cn(styles.headedGrid, {
    [styles.singleGrid]:
      myProfileValue?.programType === PROGRAM_TYPE.CAMPUS_MEDED ||
      cameFrom === PROGRAM_TYPE.CSC_PROGRAM,
    [styles.isPopupOpen]:
      isOpenPopupCard && cameFrom !== PROGRAM_TYPE.CSC_PROGRAM,
  })

  const earnTypes =
    cameFrom === PROGRAM_TYPE.CSC_PROGRAM
      ? EarnTypesDetailsCSC(avgCommission)
      : EarnTypesDetails(avgCommission)

  return (
    <div
      className={`${styles.container} ${
        isOpenPopupCard && cameFrom !== PROGRAM_TYPE.CSC_PROGRAM
          ? styles.popupOpen
          : ''
      }`}
    >
      {cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
        <Typography
          variant="heading3"
          weight="semi-bold"
          color="#1B2124"
          className={styles.heading}
        >
          How would you like to earn today?
        </Typography>
      )}

      {isOpenPopupCard && cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
        <Cross className={styles.crossIcon} onClick={onClose} />
      )}

      <div className={gridClass}>
        {earnTypes?.map((item, index) => (
          <div key={index} className={styles.card}>
            {handleActiveHeader(item)}

            <div className={styles.cardBody}>
              <CustomStepper cameFrom={cameFrom} />
              <div>
                <Typography
                  variant="regular"
                  weight="medium"
                  color="#3D3D3D"
                  component="p"
                  className={styles.description}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.para1 }} />
                </Typography>

                <Typography
                  variant="regular"
                  weight="medium"
                  color="#3D3D3D"
                  component="p"
                  className={styles.description}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.para2 }} />
                </Typography>

                <Typography
                  variant="regular"
                  weight="medium"
                  color="#3D3D3D"
                  component="p"
                  className={styles.description}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.para3 }} />
                </Typography>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <Button
                variant="primary"
                size="large"
                className={styles.ctaButton}
                onClick={() => navigate(item.directionLink)}
                disabled={!isActive}
              >
                {item.ctaName}
              </Button>

              <img
                src={item.imageLink}
                alt={item.title}
                className={styles.cardImage}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AssistEarnCard
